import { useMemo } from 'react';

import { useAuth, useClearCache } from '@/Client/State';
import { LabeledSelect } from '@/Client/Widgets';
import { useUsers } from '@kaiizen/kai-pro-api-react-state';

/** Super admin sign-in as one of the current org's users, keeping the original session to switch back from the Account page. */
export const SuperAdminUserImpersonator = () => {
  const { credentials, credentialsMutators } = useAuth();
  const { users, isLoading } = useUsers();
  const clearCache = useClearCache();

  const items = useMemo(
    () =>
      (users ?? []).map(user => ({
        value: user.id,
        label: user.name ? `${user.name} (${user.email ?? user.phoneNumber ?? user.id})` : (user.email ?? user.phoneNumber ?? user.id),
      })).sort((a, b) => a.label.localeCompare(b.label)),
    [users],
  );

  const impersonateUser = async (userId: string) => {
    const orgId = credentials.orgId;
    if (!orgId) return;
    const userName = items.find(i => i.value === userId)?.label ?? userId;
    console.warn('Super admin impersonating user', { targetUserId: userId, targetUserName: userName });
    await credentialsMutators.switchOrg(orgId, { userId });
    await clearCache();
    setTimeout(() => window.location.reload(), 1000);
  };

  return (
    <LabeledSelect
      label='Impersonate a user in this org'
      value=''
      placeholder={isLoading ? 'Loading users...' : 'Select user to impersonate...'}
      items={items}
      onChange={impersonateUser}
      emptyMessage='No users in org'
      disabled={isLoading}
    />
  );
};
